// Module
var code = `<simple-table
    get-table-data="features.game_modes_usage_table_data"
    caption-text="Сводная таблица использования игровых режимов"
    caption-url="https://confluencen.amt-games.com/pages/viewpage.action?pageId=51644221"
>
</simple-table>
`;
// Exports
module.exports = code;